<template>
  <analytics-sub-page
    title="Rewards Analytics"
    icon="gift"
    css-class="analytics-rewards"
    default-label="Rewards"
    :section-specs="sectionSpecs"
  >
    <rewards-metrics ref="rewardsRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import RewardsMetrics, { rewardsMetricsSections } from '@/pages/analyticsApp/components/RewardsMetrics.vue';

const rewardsRef = ref(null);

// RewardsMetrics carves itself into two logical subsections (the counter-card
// "Activity" row and the "Trending brands" panel). The section descriptors
// live with the component so this tab and the homepage "Download all" capture
// stay in sync.
const sectionSpecs = rewardsMetricsSections(rewardsRef);
</script>
